import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Storage from 'vue-ls';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { setDocumentTitle } from '@/utils/domUtil';

Vue.config.productionTip = false;
import 'vant/lib/index.css';
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Button,
  Notify,
  Dialog,
  Form,
  Field,
  RadioGroup,
  Radio,
  Swipe,
  SwipeItem,
  Tabbar,
  TabbarItem,
  Step,
  Steps,
  Icon,
  Stepper,
  Popup,
  Tab,
  Tabs,
  Empty,
  Cell,
  CellGroup,
  PullRefresh,
  List,
  Sticky,
  Uploader,
  Switch,
  Loading
} from 'vant';
Vue.use(Storage);
Vue.use(Checkbox)
  .use(CheckboxGroup)
  .use(Card)
  .use(SubmitBar)
  .use(Toast)
  .use(Button)
  .use(Notify)
  .use(Dialog)
  .use(Form)
  .use(Field)
  .use(RadioGroup)
  .use(Radio)
  .use(Swipe)
  .use(SwipeItem)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Step)
  .use(Steps)
  .use(Icon)
  .use(Stepper)
  .use(Popup)
  .use(Tab)
  .use(Tabs)
  .use(Empty)
  .use(Cell)
  .use(CellGroup)
  .use(PullRefresh)
  .use(List)
  .use(Sticky)
  .use(Uploader)
  .use(Switch)
  .use(Loading);
//路由拦截
const whiteList = [
  'login',
  'loginPwd',
  'loginCaptcha',
  'register',
  'rePwd',
  'join',
  'forward',
  'layout',
  'home'
];
router.beforeEach((to, from, next) => {
  //修改标题
  if (to.meta.title) {
    setDocumentTitle(`${to.meta.title} - ${baseData.siteTitle}`);
  }
  if (Vue.ls.get(ACCESS_TOKEN)) {
    if (to.name == 'home') {
      next();
    } else {
      if (store.getters.roles.length === 0) {
        store
          .dispatch('GetInfo')
          .then((res) => {
            const redirect = decodeURIComponent(from.query.redirect || to.path);
            if (to.path === redirect) {
              next({ ...to, replace: true });
            } else {
              // 跳转到目的路由
              next({ path: redirect });
            }
          })
          .catch((error) => {
            Toast.fail('登录失效');
            setTimeout(() => {
              store.dispatch('Logout').then((res) => {
                location.reload();
              });
            }, 500);
          });
          store.dispatch('GetAccount');
      } else {
        next();
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }
});

new Vue({
  router,
  store,
  render: function(h) {
    return h(App);
  }
}).$mount('#app');
